<div class="modal-content m-0">
  <div class="modal-header">
    <p class="mb-0">{{ 'followUps.modal.createFollowUpsTitle' | translate }}</p>
    <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="close()"></i>
  </div>
  <div class="modal-body">
    <div class="row" [formGroup]="form">
      <div class="col-12 col-lg-6">
        <div class="row align-items-center">
          <div class="col-12">
            <div>
              <label for="type" class="label form-control-label ps-0 pb-2">{{
                'followUps.modal.labels.type' | translate
              }}</label>
            </div>
            <app-select
              formControlName="type"
              id="type"
              [placeholder]="'followUps.modal.placeholders.type' | translate"
              data-cy="follow-ups-create-select-type"
            >
              @for (type of followUpTypes(); track type) {
                <app-select-option
                  [value]="type"
                  [label]="'followUps.types.' + type | translate"
                />
              }
            </app-select>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-12">
            <div>
              <label for="reason" class="label form-control-label ps-0 pb-2">{{
                'followUps.modal.labels.reason' | translate
              }}</label>
            </div>
            <app-select
              formControlName="reason"
              id="reason"
              [placeholder]="
                followUpReasons().length === 0
                  ? 'Select type first...'
                  : ('followUps.modal.placeholders.reason' | translate)
              "
              data-cy="follow-ups-create-select-reason"
            >
              @for (reason of followUpReasons(); track reason) {
                <app-select-option
                  [value]="reason"
                  [label]="'followUps.reasons.' + reason | translate"
                />
              }
            </app-select>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 d-flex flex-column">
        <div>
          <p class="caption mb-0">
            Entities to create follow ups for: {{ linkIds?.length ?? 0 }}
          </p>
          <hr class="mt-1" />
        </div>
        <div style="max-height: 300px">
          <app-data-table
            [configuration]="followUpEntitiesDataTable"
          ></app-data-table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-primary"
      [disabled]="form.invalid || loading()"
      (click)="submit()"
    >
      @if (loading()) {
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      } @else {
        {{ 'followUps.modal.buttons.create' | translate }}
      }
    </button>
  </div>
</div>
